import * as React from "react";
import ReceiveView from "./ReceiveView";
import Model from "hooks/Model";

function ReceiveScreen() {
  React.useEffect(() => {
    Model.setData("layoutConfig", { withBg: true });
  }, []);
  return <ReceiveView />;
}

export default ReceiveScreen;
